import './App.css';
import ProjectCard from "./components/ProjectCard/ProjectCard";

function App() {

  const projects = [
    { id: 1, title: "Arbocharta", text: "Piattaforma accessibile da desktop e mobile, pensata per agronomi e tecnici del verde, per mappare sul campo asset agronomici, raccogliere dati qualificanti e ottenere esportazioni georeferenziate utili per analisi e report." },
    { id: 2, title: "???", text: "" },
    { id: 3, title: "???", text: "" }
  ];

  return (
    <div className="App">
      <div className="bg"></div>
      <div className="bg bg2"></div>
      <div className="bg bg3"></div>

      <header className="header">
        <div className="logo-container">
          <img src="/logo.svg" alt="Leonardo Belotti Logo" className="logo" />
          <h1>Leonardo Belotti</h1>
        </div>
        <nav>
          <a href="#about">Chi sono</a>
          <a href="#projects">Progetti</a>
          <a href="#contacts">Contatti</a>
        </nav>
      </header>

      <main>
        <section id="about" className="section about">
          <div className="content animated-content">
            <div className='text-box'>
              <h2 className="fade-slide-in">Benvenuto!</h2>
              <p className="fade-slide-in delay">
                Sono uno sviluppatore full-stack con un’attenzione particolare alla qualità del codice. Mi adatto facilmente a diversi tipi di progetti, dalle applicazioni web più semplici a quelle più complesse, e sono aperto a nuove iniziative, anche con ruoli di coordinamento o gestione tecnica.
              </p>
            </div>
          </div>
        </section>

        <section id="projects" className="section projects">
          <div className="content animated-content">
            <h2 className="fade-slide-in">Progetti</h2>
            <div className="projects-grid">
              {projects.map((proj, index) => (
                <ProjectCard key={proj.id} id={proj.id} title={proj.title} text={proj.text}></ProjectCard>
              ))}
            </div>
          </div>
        </section>

        <section id="contacts" className="section contacts">
          <div className="content animated-content">
            <h2 className="fade-slide-in">Contatti</h2>
            <div className='text-box'>
              <p className="fade-slide-in delay">
                Se sei interessato a collaborare, hai un’idea da sviluppare o vuoi semplicemente entrare in contatto,
                sentiti libero di scrivermi. Sono sempre aperto a nuove opportunità e progetti stimolanti.
              </p>
              <p style={{ marginTop: "1rem" }}>
                <a href="mailto:leonardo.belotti.dev@gmail.com">Contattami</a>
              </p>
            </div>
          </div>
        </section>
      </main>

      <footer>
        © {new Date().getFullYear()} Leonardo Belotti. Tutti i diritti riservati.
      </footer>
    </div>
  );
}

export default App;
